import { Modal, Box, IconButton, Typography } from "@mui/material"
import {
  prevButtonStyle,
  nextButtonStyle,
  modalStyle,
  viewportStyle,
  closeButtonStyle,
  trackStyle,
  slideStyle,
  slideImageStyle,
  counterStyle,
} from "./style"
import { useImageGalleryModalLogic } from "./useImageGalleryModalLogic"
import { IconClose } from "../../icons/IconClose"
import { COLORS } from "../../styles/variables"
import { ChevronLeftRoundedIcon } from "../../icons/ChevronLeftRoundedIcon"
import { ChevronRightRoundedIcon } from "../../icons/ChevronRightRoundedIcon"

interface Props {
  open: boolean
  onClose: () => void
  images: string[] | null
  initialIndex?: number
}

export const ImageGalleryModal = ({
  open,
  onClose,
  images,
  initialIndex = 0,
}: Props) => {
  const {
    isMobile,
    isSingle,
    currentIndex,
    viewportRef,
    trackRef,
    onTouchStart,
    onTouchMove,
    onTouchEnd,
    onPointerDown,
    onTrackClick,
    handlePrev,
    handleNext,
  } = useImageGalleryModalLogic({ open, onClose, images: images ?? [], initialIndex })

  if (!open || !images?.length) return null

  const showGalleryChrome = !isSingle

  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={modalStyle}
    >
      <Box ref={viewportRef} sx={{ ...viewportStyle, touchAction: "none" }}>
        <IconButton
          data-gallery-chrome
          onClick={onClose}
          sx={closeButtonStyle}
        >
          <IconClose sx={{ color: COLORS.WHITE }} />
        </IconButton>

        {showGalleryChrome && !isMobile && (
          <>
            <IconButton
              data-gallery-chrome
              disabled={currentIndex === 0}
              onClick={handlePrev}
              sx={prevButtonStyle}
            >
              <ChevronLeftRoundedIcon fontSize="large" />
            </IconButton>
            <IconButton
              data-gallery-chrome
              disabled={currentIndex === images.length - 1}
              onClick={handleNext}
              sx={nextButtonStyle}
            >
              <ChevronRightRoundedIcon fontSize="large" />
            </IconButton>
          </>
        )}

        <Box
          ref={trackRef}
          sx={trackStyle}
          onTouchStart={onTouchStart}
          onTouchMove={onTouchMove}
          onTouchEnd={onTouchEnd}
          onPointerDown={onPointerDown}
          onClick={onTrackClick}
        >
          {images.map((src, idx) => (
            <Box key={`${idx}-${src}`} sx={slideStyle(isMobile)}>
              <Box
                component="img"
                data-gallery-image
                src={src}
                alt=""
                draggable={false}
                sx={slideImageStyle}
              />
            </Box>
          ))}
        </Box>
        {showGalleryChrome && isMobile && (
          <Typography variant="h3" sx={counterStyle}>
            {currentIndex + 1} / {images.length}
          </Typography>
        )}
      </Box>
    </Modal>
  )
}
